module.exports = __webpack_public_path__ + "static/img/m_sidebar_home@3x.6cd6e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_sidebar_home@3x.png
// module id = nufX
// module chunks = 1